import clsx from "clsx"
import React from "react"

export interface StatProps {
  number?: string
  description: string | undefined
  className?: string
  size?: "md" | "lg"
  theme?: "dark" | "light"
  textColor?: string
  image?: React.ReactNode
}

const StatRow: React.FC<StatProps> = ({
  number = "",
  description = "",
  className = "",
  size = "md",
  theme = "dark",
  textColor = "",
  image = null,
}) => (
  <div className={clsx(className, "text-gray-90")}>
    {image && image}
    {number && (
      <p
        className={clsx(
          "mb-2 font-bold",
          theme === "dark" ? "blue-gradient-dark" : "blue-gradient-light",
          size === "md" ? "headline4" : "headline2",
        )}
      >
        {number}
      </p>
    )}
    <p className={clsx("body3", textColor)}>{description}</p>
  </div>
)

export default StatRow
